<template>
  <div class="page__main--890">
    <header class="m-b-xxl">
      <h1 class="m-b-m">Colors</h1>
      <p class="m-b-xl"><fds-text type="lead">Our sets of colors used for typography, icons, and UI components.</fds-text></p>
    </header>
    <h2 class="m-b-s">Primary Colors</h2>
    <p class="m-b-xl">Used in the Feelgood logotype, typography and UI components.</p>
    <div class="color-wrapper">
      <section class="colors" v-for="(colors, category, index) in showColors" :key="category">
        <span v-if="index === 4">
          <h2 class="text-capitalize m-b-s m-t-none">Secondary Colors</h2>
          <p class="m-b-xl">Mainly used in UI components and some graphs.</p>
        </span>
        <h3 class="text-capitalize m-b-l m-t-none">{{ colorName(category) }}</h3>
        <div class="colors__content">
          <Swatch v-for="color in colors" :key="color.name" :data="color" :index="index"/>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import tokens from '../../../node_modules/fds-core/dist/fds-core/globals/style/export.scss'
import Swatch from './Swatch'

export default {
  name: 'Colors',
  components: {
    Swatch
  },
  computed: {
    showColors () {
      const colorMap = {}
      let currColor = ''
      for (const prop in tokens) {
        if (prop.split('-')[0] === 'color') {
          var category = prop.split('-').slice(1, 2).join('-')
          if (!currColor || category !== currColor) {
            currColor = category
            colorMap[category] = []
          }
          colorMap[category].push({ name: prop, color: tokens[prop] })
        }
      }
      return colorMap
    }
  },
  methods: {
    colorName (name) {
      switch (name) {
        case 'blue':
          return 'Blue'
        case 'red':
          return 'Red'
        case 'gray':
          return 'Gray'
        case 'white_t':
          return 'White'
        case 'yellow':
          return 'Orange / Yellow'
        case 'green':
          return 'Green'
        case 'blue_t':
          return 'Blue (Transparent)'
        default:
          return 'Missing color'
      }
    },
    mapColorTexts (category) {
      const categories = {
        'black (transparent)': 'Mainly used for typography and for components.',
        blue: 'Primary brand color. Mainly used for components and icons.',
        'blue (transparent)': 'Used for visual details in various components.',
        gray: 'Complementary color set not used, yet...',
        green: 'Mainly used for form validation and some icons.',
        red: 'Primary brand color. Used for various components, form validation and some icons.',
        'white (transparent)': 'Used for some components.',
        yellow: 'Used extensively for getting users attention.'
      }
      if (categories[category]) {
        return categories[category]
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.color-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: set-gutter('xxl');
  @media all and (min-width: set-bp('xl')) {
    grid-template-columns: 1fr 1fr;
  }
}
.colors {
  margin-bottom: set-gutter('xl');
  &:nth-child(6) {
    @media all and (min-width: set-bp('xl')) {
      margin-top: 86px;
    }
  }
  &__content {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: set-gutter('m');
  }
}
</style>
